import './image-content.scss';
